import { useState } from "react";
import { API_URL } from "../../context/AuthContext";
import {
  Alert,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";

interface PasswordDialogProps {
  open: boolean;
  onClose: () => void;
  token: string | null;
}

export default function PasswordDialog({ open, onClose, token }: PasswordDialogProps) {
  const [current, setCurrent] = useState("");
  const [newPass, setNewPass] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setError("");
    setSuccess("");
    if (!current || !newPass) { setError("Wypełnij wszystkie pola"); return; }
    if (newPass.length < 6) { setError("Hasło musi mieć co najmniej 6 znaków"); return; }
    if (newPass !== confirm) { setError("Hasła nie są identyczne"); return; }

    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/auth/password`, {
        method: "PUT",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ currentPassword: current, newPassword: newPass }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error);
      setSuccess("Hasło zmienione");
      setCurrent(""); setNewPass(""); setConfirm("");
    } catch (e: any) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => { setCurrent(""); setNewPass(""); setConfirm(""); setError(""); setSuccess(""); onClose(); };

  return (
    <Dialog open={open} onClose={handleClose} PaperProps={{ sx: { backgroundColor: "#2a2a2a", color: "#f0f0f0" } }}>
      <DialogTitle>Zmień hasło</DialogTitle>
      <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, pt: "16px !important" }}>
        {error && <Alert severity="error">{error}</Alert>}
        {success && <Alert severity="success">{success}</Alert>}
        <TextField type="password" label="Obecne hasło" value={current} onChange={(e) => setCurrent(e.target.value)} fullWidth InputProps={{ sx: { color: "#f0f0f0" } }} InputLabelProps={{ sx: { color: "#aaa" } }} />
        <TextField type="password" label="Nowe hasło" value={newPass} onChange={(e) => setNewPass(e.target.value)} fullWidth InputProps={{ sx: { color: "#f0f0f0" } }} InputLabelProps={{ sx: { color: "#aaa" } }} />
        <TextField type="password" label="Powtórz nowe hasło" value={confirm} onChange={(e) => setConfirm(e.target.value)} fullWidth InputProps={{ sx: { color: "#f0f0f0" } }} InputLabelProps={{ sx: { color: "#aaa" } }} />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} sx={{ color: "#aaa" }}>Anuluj</Button>
        <Button onClick={handleSubmit} disabled={loading} variant="contained" sx={{ backgroundColor: "#1976d2", "&:hover": { backgroundColor: "#125ea8" } }}>
          {loading ? "Zapisywanie..." : "Zmień hasło"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
